import { CaregiverCallTimelineTab } from '@apps/web/components/caregivers/caregiver_call_timeline_tab';

type ClientCallTimelineTabProps = {
    readonly organizationId: string;
    readonly clientId: string | null;
    readonly organizationTimezone: string | null;
};

export function ClientCallTimelineTab({
    organizationId,
    clientId,
    organizationTimezone,
}: ClientCallTimelineTabProps) {
    return (
        <CaregiverCallTimelineTab
            organizationId={organizationId}
            clientId={clientId}
            organizationTimezone={organizationTimezone}
        />
    );
}
